module.exports = __webpack_public_path__ + "static/assets/f8916607225adec64cb5c459495aa4c8.png";